import videoServices from '../../services/video';
import Video from '../../model/video';

export const state = {
    videos: [],
    video: {},
}

export const mutations = {
    setVideo(state, video) {
        state.video = video
    },
    setVideos(state, videos) {
        state.videos = videos
    },
    addVideo(state, video) {
        state.videos = [video, ...state.videos]
    },
}

export const getters = {
    getVideo(state) {
        return new Video(state.video);
    },
    getVideos(state) {
        return state.videos.map((p)=>new Video(p))
    },
}

export const actions = {
    get({commit}, id){
        return videoServices.get(id)
        .then((response)=>{
            commit('setVideo', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return videoServices.getAll(data)
        .then((response)=>{
            commit('setVideos', response.data.data)
            return response
        })
    },
    add({commit}, video){
        return videoServices.add(video)
        .then((response)=>{
            commit('addVideo', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, video}){
        return videoServices.edit(id, video)
        .then((response)=>{
            let videos = state.videos
            videos[videos.findIndex((x)=>x.id == id)] = response.data.data
            commit('setVideos', videos)
            return response
        })
    },
    delete({commit}, id){
        return videoServices.delete(id)
        .then((response)=>{
            commit('setVideos', (state.videos.filter((x)=>x.id != id)))
            return response
        })
    },
}